import { render, staticRenderFns } from "./RoomLock.vue?vue&type=template&id=484e667a&scoped=true"
import script from "./RoomLock.vue?vue&type=script&lang=js"
export * from "./RoomLock.vue?vue&type=script&lang=js"
import style0 from "./RoomLock.vue?vue&type=style&index=0&id=484e667a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484e667a",
  null
  
)

export default component.exports